<template>
  <loading-overlay :show="show_overlay" :default="true">
    <div class="card pending-card">
      <div class="card-header">
        <div class="heading-small">Pending</div>
        <div class="subheading-table" :class="{'color-orange-sun' : _selected_projects.length}">{{ _selected_projects.length }} projects selected</div>
        <div>
          <div class="btn btn-silent" :disabled="_selected_projects.length === 0" @click="groupSelectedProjects">
            Group projects <span v-if="_selected_projects.length > 0">({{ _selected_projects.length }})</span>
          </div>
          <div class="btn btn-silent" :disabled="_selected_invoicable_projects.length === 0" @click="openInvoicingModal()">
            Generate invoices <span v-if="_selected_invoicable_projects.length > 0">({{ _selected_invoicable_projects.length }})</span>
          </div>
          <div class="btn btn-silent" :disabled="_selected_sendable_invoices.length === 0" @click="sendInvoices()">
            Send <span v-if="_selected_sendable_invoices.length > 0">({{ _selected_sendable_invoices.length }})</span>
          </div>
        </div>
      </div>
      <div class="card-body">
        <table>
          <tr>
            <th></th>
            <th>Client</th>
            <th>Predicted income</th>
            <th>Current income</th>
            <th>Group</th>
            <th>Invoice</th>
            <th>Actions</th>
          </tr>
          <template v-for="client in pending_clients">
            <tr @click="expandClient(client)">
              <td class="bulk-select">
                <div class="checkbox">
                  <input type="checkbox" v-model="client.selected" @click.stop="selectClient($event, client)">
                </div>
                <div class="expand">
                  <i v-if="client.id === expanded_client" class="fas fa-chevron-down"></i>
                  <i v-else class="fas fa-chevron-right"></i>
                </div>
              </td>
              <td class="table-strong">{{ client.client_name }}</td>
              <td>
                <span v-if="client.predicted_income > 0" class="table-strong">{{ client.predicted_income }}&euro;</span>
                <span v-else class="text-detail">-</span>
              </td>
              <td>
                <span v-if="client.generated_money > 0" class="table-strong">{{ client.generated_money }}&euro;</span>
                <span v-if="client.credited_amount > 0" class="table-strong">(-{{ client.credited_amount }}&euro;)</span>
                <span v-if="client.generated_money === 0 && client.credited_amount === 0" class="text-detail">-</span>
              </td>
              <td></td>
              <td></td>
              <td class="actions">
                <button type="button" class="btn btn-secondary" @click.stop="generateInvoicesForClient(client)">
                  <i class="fas fa-file"></i>
                </button>
                <button type="button" class="btn btn-secondary" :disabled="client.sendable_invoices.length === 0" @click.stop="sendInvoices(client.sendable_invoices)">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </td>
            </tr>

            <!--projects-->
            <tr class="project" v-for="project in client.projects" v-if="client.id === expanded_client">
              <td></td>
              <td class="subheading-table">
                <div class="checkbox">
                  <input type="checkbox" v-model="project.selected">
                </div>
                {{ project.project_name }}
              </td>
              <td>
                <span v-if="project.predicted_income > 0" class="table-strong">{{ project.predicted_income }}&euro;</span>
                <span v-else class="text-detail">-</span>
              </td>
              <td>
                <span v-if="project.credited_amount > 0" class="table-strong">-{{ project.credited_amount }}&euro;</span>
                <span v-if="project.credited_amount === 0 && project.generated_money > 0" class="table-strong">{{ project.generated_money }}&euro;</span>
                <span v-if="project.credited_amount === 0 && project.generated_money === 0" class="text-detail">-</span>
              </td>
              <td>
                {{ project.group_id }}
              </td>
              <td>
                <div class="invoice-buttons" v-if="project.invoice">
                  <a class="chip chip-orange" :href="project.invoice.preview_url" v-if="project.invoice" target="_blank">
                    #{{ project.invoice.full_number }}
                  </a>
                  <span class="trash-can ml-1" @click="destroy(project.invoice.id)">
                    <i class="fas fa-trash-alt"></i>
                  </span>
                </div>
              </td>
              <td class="actions">
                <button type="button" class="btn btn-secondary" @click="generateSingleInvoice(project)">
                  <i class="fas fa-file"></i>
                </button>
                <button type="button" class="btn btn-secondary" :disabled="!project.can_send_invoice" @click="sendInvoices([project.invoice.id])">
                  <i class="fas fa-paper-plane"></i>
                </button>
              </td>
            </tr>
            <!--projects-->
          </template>
          <total-tr :fill="4" :clients="pending_clients"></total-tr>
        </table>
        <invoicing-modal></invoicing-modal>
      </div>
    </div>
  </loading-overlay>
</template>
<script>
import InvoicingModal from './InvoicingModal.vue'
import TotalTr from './TotalTr.vue'
import LoadingOverlay from './LoadingOverlay'


export default {
  components: {
    InvoicingModal,
    TotalTr,
    LoadingOverlay,
  },
  props: {
    startDate: {
      required: true,
    },
    endDate: {
      required: true,
    }
  },
  created() {
    this.loadPendingClients()

    this.$root.$on('Invoices::expandClient', client_id => {
      if (client_id === this.expanded_client) {
        this.expanded_client = null
        return
      }

      this.expanded_client = client_id
    })

    this.$root.$on('Invoices::changeDate', () => {
      this.loadPendingClients()
    })

    this.$root.$on('Invoices::reloadIndexTables', () => {
      this.loadPendingClients()
    })

  },
  data() {
    return {
      pending_clients: null,
      invoice_button_disabled: false,
      expanded_client: null,
      loading: false,
      last_invoice_number: null,
      show_overlay: false,
    }
  },
  computed: {
    _selected_sendable_invoices() {
      return _.uniq(_.map(this._selected_sendable_projects, p => p.invoice.id))
    },
    _selected_sendable_projects() {
      return _.filter(this._selected_projects, p => p.can_send_invoice)
    },
    _selected_invoicable_projects() {
      return _.filter(this._selected_projects, p => p.can_invoice)
    },
    _selected_projects() {
      let projects = _.flatMap(this.pending_clients, c => c.projects)
      return _.filter(projects, p => p.selected)
    }
  },
  methods: {
    loadPendingClients() {
      this.show_overlay = true
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
      }
      this.loading = true
      this.axios.get('/invoices2/pending', {params: data}).then(response => {
        this.pending_clients = response.data.data
        this.last_invoice_number = response.data.last_invoice_number
        this.loading = false
      }).catch(e => {
        this.loading = false
      }).finally(() => {
        this.deselectAll()
        this.show_overlay = false
      })
    },
    expandClient(client) {
      this.$root.$emit('Invoices::expandClient', client.id)
    },
    groupSelectedProjects() {
      let projects = _.map(this._selected_projects, p => p.id)
      this.axios.post('projects/group', {projects}).then(response => {
        let updatedProjects = response.data.data

        _.each(updatedProjects, updatedProject => {
          let client = _.find(this.pending_clients, c => c.id === updatedProject.client_id)
          let project = _.find(client.projects, p => p.id === updatedProject.id)
          project.group_id = updatedProject.group_id
        })
      }).catch(err => {
        console.log(err)
      })
    },
    openInvoicingModal(projects = null) {
      this.$root.$emit('Invoices::openInvoicingModal', {
        projects: projects || this._selected_invoicable_projects,
        startDate: this.startDate,
        endDate: this.endDate,
        last_invoice_number: this.last_invoice_number,
      })
    },
    selectClient($e, client) {
      let checked = $e.target.checked
      this.$set(client, 'selected', checked)
      _.each(client.projects, project => {
        this.$set(project, 'selected', checked)
      })
    },
    deselectAll() {
      _.each(this.pending_clients, client => {
        this.$set(client, 'selected', false)
        _.each(client.projects, project => {
          this.$set(project, 'selected', false)
        })
      })
    },
    sendInvoices(invoices = null) {
      if (!confirm('Are you sure?')) {
        return;
      }

      invoices = invoices || this._selected_sendable_invoices
      this.axios.post('invoices2/send', {invoices}).then(response => {
        this.$root.$emit('Invoices::reloadIndexTables')
      })
    },
    destroy(id) {
      if (!confirm('Are you sure?')) return
      this.axios.delete('invoices2/' + id).then(response => {
        this.$root.$emit('Invoices::reloadIndexTables')
      }).catch(e => {
        console.log(e)
      })
    },
    generateSingleInvoice(project) {
      this.deselectAll()
      this.openInvoicingModal([project])
    },
    generateInvoicesForClient(client) {
      let projects = _.filter(client.projects, project => project.can_invoice)
      this.openInvoicingModal(projects)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoices2/PendingClients.vue